var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHttp } from '../../../hooks/useHttp';
import { useMessage } from '../../../hooks/useMessage';
import { useTypeDispatch } from '../../../hooks/useTypeDispatch';
import { fetchJuOrju } from '../../../redux/action/juOrjuAction';
import styles from './tkSettings.module.scss';
/**
 * Переключатель «Преподаватели сами вносят своё расписание».
 *
 * Функция есть только у вуза без расписания в AVN: там преподаватель сам
 * вносит свою неделю на странице «Моё расписание», и журнал открывается из
 * «Сегодня». Деканат может её выключить — тогда все ведут журнал через
 * обычную форму, а внесённые пары просто лежат до включения.
 *
 * Отдельным блоком, как расчёт ТК: общая таблица настроек приходит из
 * вузовской процедуры с закрытым списком кодов.
 */
const OwnScheduleSetting = () => {
    const { t } = useTranslation();
    const { request } = useHttp();
    const toast = useMessage();
    const dispatch = useTypeDispatch();
    const [state, setState] = React.useState(null);
    const [busy, setBusy] = React.useState(false);
    React.useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const { data } = yield request('/teacher/own-schedule-setting');
            if (data)
                setState(data);
        }))();
    }, []);
    const save = (on) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setBusy(true);
        const res = yield request('/teacher/own-schedule-setting', 'PUT', { on_off: on ? 1 : 0 });
        setBusy(false);
        if ((res === null || res === void 0 ? void 0 : res.type) !== 'success' || !((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.updated)) {
            return toast((res === null || res === void 0 ? void 0 : res.message) || String(t('error_generic')), 'error');
        }
        setState(prev => (prev ? Object.assign(Object.assign({}, prev), { on_off: on ? 1 : 0 }) : prev));
        toast(String(t('saved')), 'success');
        // Меню и баннер на форме берут признак отсюда — обновляем сразу.
        dispatch(fetchJuOrju());
    });
    // У вуза с расписанием в AVN функции нет вовсе; строки нет — скрипт
    // настройки ещё не накатили, переключать нечего.
    if (!state || state.scheduleInAvn || !state.exists)
        return null;
    return (_jsxs("section", Object.assign({ className: styles.block }, { children: [_jsx("header", Object.assign({ className: styles.head }, { children: _jsx("h4", { children: t('own_setting_title') }) })), _jsxs("div", Object.assign({ className: styles.row }, { children: [_jsxs("div", Object.assign({ className: styles.text }, { children: [_jsx("div", Object.assign({ className: styles.label }, { children: t('own_setting_on') })), _jsx("div", Object.assign({ className: styles.hint }, { children: t('own_setting_hint') }))] })), _jsxs("label", Object.assign({ className: styles.switch }, { children: [_jsx("input", { id: "own-schedule-setting", type: "checkbox", checked: Number(state.on_off) === 1, disabled: busy, onChange: e => save(e.target.checked) }), _jsx("span", {})] }))] }))] })));
};
export default OwnScheduleSetting;
